import { type Driver } from '../domain/Driver'

export type RawDriver = {
  id?: string
  name: string
  phone_number: string
  sms?: boolean
}

export function mapApiToDriver(rawDriver: RawDriver): Driver {
  return {
    id: rawDriver.id,
    name: rawDriver.name,
    phoneNumber: rawDriver.phone_number,
    sms: Boolean(rawDriver.sms),
  }
}

export function mapDriverToApi(driver: Driver): RawDriver {
  return {
    id: driver.id,
    name: driver.name,
    phone_number: driver.phoneNumber,
    sms: Boolean(driver.sms),
  }
}
